import { post } from "./api";

export const createForgotPassword = (data) => {
  return post("/api/v2/forgotpassword/", data);
};

export const login = (user) => {
  return post("/api/v2/token/", user);
};

export const logout = (data) => {
  return post("/api/v2/logout/", data);
};

export const resetPassword = (data) => {
  return post("/api/v2/resetpassword/", data);
};
